import { BaseExportModal, ExportModalProps } from './ExportModal'
import { NURSING_HOME_COLUMNS } from 'components/DataExpansionComponents/NursingHomes/nursingHomeColumnsInfo'
import { createExportColumnHelper } from 'components/DataExpansionComponents/Common/commonColumnHelpers'
import { getCommonChainProxyExportColumns } from 'components/DataExpansionComponents/Common/commonExportColumns'
import { useDownload } from 'features/download-widget'
import {
  getDownloadStatus,
  startNursingHomesExportV2,
} from 'services/downloadsApi'
import { useColumnStoreContext } from 'stores/ColumnsStore/useColumnsStoreContext'

export default function NursingHomeExportModal(props: ExportModalProps) {
  const nursingHomeColumnHelper = createExportColumnHelper({
    columns: NURSING_HOME_COLUMNS,
  })

  const selectedColumns = useColumnStoreContext(
    (state) => state.selectedColumns
  )
  const { startDownload } = useDownload()

  const columns = [
    {
      title: 'Target Attributes',
      elements: [
        nursingHomeColumnHelper.retrieveColumn('provider_name'),
        nursingHomeColumnHelper.retrieveColumn('address'),
        nursingHomeColumnHelper.retrieveColumn('city'),
        nursingHomeColumnHelper.retrieveColumn('state'),
        nursingHomeColumnHelper.retrieveColumn('zip_code'),
        nursingHomeColumnHelper.retrieveColumn('domain'),
        nursingHomeColumnHelper.retrieveColumn('website_url'),
      ],
    },
    {
      title: 'Senior Living Insights',
      elements: [
        nursingHomeColumnHelper.retrieveColumn('number_of_certified_beds'),
        nursingHomeColumnHelper.retrieveColumn(
          'average_number_of_residents_per_day'
        ),
        nursingHomeColumnHelper.retrieveColumn('overall_rating'),
        nursingHomeColumnHelper.retrieveColumn('health_inspection_rating'),
        nursingHomeColumnHelper.retrieveColumn('qm_rating'),
        nursingHomeColumnHelper.retrieveColumn('staffing_rating'),
        nursingHomeColumnHelper.retrieveColumn('projected_meals_per_day'),
        nursingHomeColumnHelper.retrieveColumn('affiliated_entity_name'),
        nursingHomeColumnHelper.retrieveColumn('ownership_type'),
        nursingHomeColumnHelper.retrieveColumn('provider_type'),
        nursingHomeColumnHelper.retrieveColumn(
          'continuing_care_retirement_community'
        ),
      ],
    },
    {
      title: 'Predicted Values and Deals',
      elements: getCommonChainProxyExportColumns(),
    },
  ]

  const onSubmit = async (
    selectedCols: string[],
    exportType: 'csv' | 'xlsx'
  ) => {
    await startDownload({
      items: [{ id: 0, name: 'Exporting Senior Living...' }],
      initiate: async () => {
        const { sort, ...filterWithoutSort } = (props.filters ?? {}) as Record<
          string,
          unknown
        >
        const response = await startNursingHomesExportV2({
          selected_columns: selectedCols,
          export_type: exportType,
          filter_params: {
            ...filterWithoutSort,
            include_ids: props.selectedIds ?? [],
            exclude_ids: props.excludeIds ?? [],
          },
          sort: sort as string | undefined,
        })
        return { type: 'async', requestId: response.request_id }
      },
      getStatus: getDownloadStatus,
      label: 'Senior Living',
    })
  }

  return (
    <BaseExportModal
      title="Select Columns for Senior Living Download"
      subTitle="Download up to 10,000 senior living locations at a time, with any of the following columns. Any filters already applied will remain active."
      submitText="Export Senior Living"
      columns={columns}
      selectedColumns={selectedColumns}
      onSubmit={onSubmit}
      show={props.show}
      handleClose={props._handleClose}
    />
  )
}
